import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableHelper, FilterParameter } from 'common';
import { ClientQueryParams, ClientFilters } from './client.data';

@Injectable({
    providedIn: 'root'
})
export class ClientFilterService {

    constructor(
        private router: Router
    ) { }

    filter(filters: ClientFilters, paginator?: MatPaginator, sort?: MatSort) {
        const query: ClientQueryParams = filters;

        // Set default to first page
        query.skip = undefined;

        if (paginator) {
            query.limit = paginator.pageSize;
            query.skip = paginator.pageIndex * paginator.pageSize;
        }

        if (sort && sort.active) {
            query.sort = MatTableHelper.getSort(query.sort, sort);
        }


        this.router.navigate(['admin', 'client'], { replaceUrl: true, queryParams: query });
    }

    addFilterParameters(query: ClientQueryParams): FilterParameter[] {
        // Refresh filters chip list
        const filters: FilterParameter[] = [];

        if (query.name) {
            filters.push({
                id: 'name', name: 'Name', value: query.name.trim()
            });
        }
        if (query.oidcAudience) {
            filters.push({
                id: 'oidcAudience', name: 'OIDC audience', value: query.oidcAudience.trim()
            });
        }
        if (query.active) {
            filters.push({
                id: 'active', name: 'Status', value: query.active.toString() === 'true' ? 'Active' : 'Inactive'
            });
        }

        return filters;
    }
}
